<template>
  <div>
    <h2>Factures</h2>
  </div>
</template>

<script setup>
// Factures logic here
</script>

<script>
export default {
  name: 'FacturesView',
}
</script> 